import { render, staticRenderFns } from "./StudentsEditDataGeneral.vue?vue&type=template&id=45e95888"
import script from "./StudentsEditDataGeneral.vue?vue&type=script&lang=js"
export * from "./StudentsEditDataGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports